// extracted by mini-css-extract-plugin
export default {"noteDetail":"styles_noteDetail__vYL64","note":"styles_note__He6hH","readMoreLess":"styles_readMoreLess__QJTBS","noteDateTime":"styles_noteDateTime__DpGhh"};